<div *ngIf="application && productName"
     class="row no-gutters"
>

  <div class="col-12 mb-4 mb-application-title"
       data-cy="mb-application-title"
  >
    <span [innerHTML]="application?.name | safeHtml"></span>
    {{ 'mbProductTabs.applicationsFor' | mbTranslate }}
    <strong
      [innerHTML]="productName | safeHtml"
    ></strong>
  </div>

  <div class="col-12 mb-application-conjugates"
       data-cy="mb-application-conjugates"
  >
    <div class="mr-2 mb-2 cursor-pointer mb-application-conjugate"
         [attr.data-cy]="'mb-application-conjugate-' + index"
         [ngClass]="index === activeConjugateIndex ? 'active' : ''"
         *ngFor="let conjugateCode of getDistinctConjugateCodes(), index as index"
         (click)="setActiveConjugate(index, conjugateCode)"
    >
      <strong [innerHTML]="conjugateCode | safeHtml"></strong>
    </div>
  </div>

  <ng-container *ngIf="this.activeConjugateCode">
    <div *ngFor="let dataset of getDataSetsOfActiveConjugate(), index as i"
         class="col-12 mb-application-conjugate-data-entry"
         [attr.data-cy]="'mb-application-conjugate-dataset-' + i"
    >

      <div class="row no-gutters">
        <div class="col-12 col-lg-7 pr-3">

          <!-- Template for TEXT -->
          <div *ngFor="let item of getInformationItems(dataset, mbDatasetEntryTypes.TEXT)"
               class="row no-gutters mb-3 mb-lg-0"
          >

            <div class="col-12 col-lg-5 mb-application-conjugate-keys"
                 data-cy="mb-application-conjugate-keys"
            >
              <span [innerHTML]="item?.name | safeHtml"></span>
              :
            </div>

            <div class="col-12 col-lg-7"
                 data-cy="mb-application-conjugate-values"
            >
              <span [innerHTML]="item?.value | safeHtml"></span>
            </div>

          </div>

          <!-- Template for PUBLICATION -->
          <div *ngFor="let publications of getInformationItems(dataset, mbDatasetEntryTypes.PUBLICATION)"
               class="row no-gutters mb-3 mb-lg-0"
          >

            <div class="col-12 col-lg-5 mb-application-conjugate-keys"
                 data-cy="mb-application-conjugate-keys"
            >
              <span [innerHTML]="publications?.name | safeHtml"></span>
              :
            </div>

            <div class="col-12 col-lg-7"
                 data-cy="mb-application-conjugate-values"
            >
              <ng-container *ngFor="let publication of publications?.urls?.entry, index as publicationsCount">
                <span *ngIf="publicationsCount !== 0 && publicationsCount <= maxPublicationsShown">, </span>
                <a *ngIf="publicationsCount < maxPublicationsShown"
                   [innerHTML]="publication?.key | safeHtml"
                   [href]="publication?.value"
                   target="_blank"
                >
                </a>
                <a *ngIf="publicationsCount === maxPublicationsShown"
                   href="javascript:void(0)"
                   (click)="openPublicationsDialog(publications?.urls?.entry)"
                >
                  {{ 'mbProductTabs.allPublicationsLowerCase' | mbTranslate }}
                </a>
              </ng-container>
            </div>

          </div>

          <!-- Template for PROTOCOL -->
          <div *ngFor="let protocols of getInformationItems(dataset, mbDatasetEntryTypes.PROTOCOL)"
               class="row no-gutters mb-3 mb-lg-0"
          >

            <div class="col-12 col-lg-5 mb-application-conjugate-keys"
                 data-cy="mb-application-conjugate-keys"
            >
              <span [innerHTML]="protocols?.name | safeHtml"></span>
              :
            </div>

            <div class="col-12 col-lg-7"
                 data-cy="mb-application-conjugate-values"
            >
              <ng-container *ngFor="let protocol of protocols?.entries">
                <a *ngIf="protocol?.url; else protocolText"
                   [innerHTML]="protocol?.text | safeHtml"
                   [href]="protocol?.url"
                   target="_blank"
                   class="d-block"
                >
                </a>
                <ng-template #protocolText>
                  <span [innerHTML]="protocol?.text | safeHtml"></span>
                </ng-template>
              </ng-container>
            </div>

          </div>

          <!-- Template for DESCRIPTION -->
          <div *ngIf="dataset?.description"
               class="row no-gutters mb-3 mb-lg-0 mt-lg-4"
          >

            <div class="col-12 col-lg-5 mb-application-conjugate-keys"
                 data-cy="mb-application-conjugate-keys"
            >
              {{ 'mbProductTabs.description' | mbTranslate }}:
            </div>

            <div class="col-12 col-lg-7"
                 data-cy="mb-application-conjugate-values"
            >
              <span [innerHTML]="dataset?.description | safeHtml"></span>
            </div>

          </div>
        </div>

        <!-- Template for IMAGES -->

        <div *ngIf="getInformationItems(dataset, mbDatasetEntryTypes.IMAGE)  ||
                    getInformationItems(dataset, mbDatasetEntryTypes.VIDEO)"
             class="col-12 col-lg-5 pl-3"
        >
          <ng-container *ngIf="getInformationItems(dataset, mbDatasetEntryTypes.IMAGE) as images">
            <!-- Template for one image -->
            <ng-container *ngIf="images.length === 1">
              <p class="mb-2 text-break">
                <strong [innerHTML]="images[0]?.headline | safeHtml"></strong>
              </p>
              <img [src]="images[0]?.url"
                   class="img-responsive"
                   title="Application image"
                   alt="Application image"
                   aria-label="Application image"
                   data-cy="mb-application-conjugate-image"
              />
            </ng-container>

            <!-- Template for more than one images -->
            <ng-container *ngIf="images.length > 1">
              <div class="row no-gutters">
                <div *ngFor="let image of images, index as imageIndex"
                     [ngClass]="[imageIndex > 1 ? 'add-margin-top' : '', 'col-6 d-grid']"
                >
                  <p class="mb-2 align-self-start text-break">
                    <strong [innerHTML]="image?.headline | safeHtml"></strong>
                  </p>
                  <div class="cursor-pointer align-self-end mb-application-conjugate-image-wrapper"
                       (click)="openGalleryDialog(image, images, dataset?.description, getInformationItems(dataset, mbDatasetEntryTypes.VIDEO))"
                  >
                    <img [src]="image?.url"
                         class="img-responsive"
                         title="Application image"
                         alt="Application image"
                         aria-label="Application image"
                         data-cy="mb-application-conjugate-image"
                    />
                    <span>
                      <img src="assets/icons/svg/icon_search_plus.svg"
                           title="View details"
                           alt="View details"
                           aria-label="View details"
                           data-cy="mb-application-view-details"
                      />
                      {{ 'mbProductTabs.viewDetails' | mbTranslate }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="getInformationItems(dataset, mbDatasetEntryTypes.VIDEO) as videos">
            <ng-container *ngFor="let video of videos">
              <div *ngIf="getThumbnail(video?.videoId) as thumbnail"
                   mbUcBlockable
                   (unBlocked)="ngOnInit()"
                   [ucService]="ucService.MOVING_IMAGE"
                   [ucId]="video.videoId"
                   class="pt-4 pr-3"
                   (click)="openGalleryDialog(thumbnail, getInformationItems(dataset, mbDatasetEntryTypes.IMAGE), dataset?.description, videos)"
              >
                <div *ngIf="thumbnail.image"
                     class="mb-gallery-image-wrapper"
                >
                  <picture>
                    <source [srcset]="thumbnail.image">
                    <img class="mb-gallery-image h-100 img-responsive"
                         [title]="video.headline"
                         [alt]="video.headline"
                         [attr.aria-label]="'mbproduct.galleryMainImage' | mbTranslate"
                         data-cy="panel-row-video-image"
                         [src]="thumbnail.image"
                    />
                  </picture>
                  <img src="../../../../../../../assets/images/Icon_play-xl2_white.svg"
                       class="mb-thumbnail-video-play-button"
                       data-cy="mb-thumbnail-video-play-button"
                       alt="play video"
                       title="play video"
                  />
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

      </div>
    </div>
  </ng-container>

</div>
